<app-option-bar #child [type]="moduleType" [details]="moduleDetails"></app-option-bar>
<div class="container-fluid endpoint-wrapper">
  <div class="content-wrapper">
    <!-- Menu Section -->
    <div class="inner-nav">
      <app-left-menu [details]="moduleDetails" [type]="moduleType"></app-left-menu>
    </div>
    <div class="inner-content collapsed">
      <div class="col-12 d-flex pt-3">
        <div class="col-8">
          <div class="common-section">
            <div class="d-flex justify-content-between pb-1 align-items-center">
              <h5 class="common-heading"><b>Schedules</b></h5>
              <!-- <img src="/assets/images/icons/create-plus.svg" class="create-newicon" ngbTooltip="New Schedule"
                  [attr.aria-expanded]="!isCollapsed" (click)="clickToOpenSchedule()" placement="left"> -->
              <div class="d-flex">
                <button class="btn btn-sm btn-danger" *ngIf="setDeleteAll" type="button" title="Delete Schedule(s)" (click)="deleteMultipleSchedules(scheduledExecutions)">
                  Delete
                </button>
                <button class="btn btn-sm btn-primary ml-2" (click)="clickToOpenSchedule()">Create Schedule</button>
              </div>
            </div>
          </div>

          <div class="common-table">

            <div *ngIf="!scheduledExecutions" class="extra-box">No schedules found</div>
            <div class="table-responsive" *ngIf="scheduledExecutions">
              <table class="table text-center">
                <thead>
                  <tr class="font-bold">
                    <th>
                      <input type="checkbox" name="" [(ngModel)]="isAllScheduleSelected" (click)="toogleAllSchedules()" />
                    </th>
                    <th>Name</th>
                    <th>Start date time</th>
                    <th>Cron</th>
                    <th *ngIf="moduleType === 'ENDPOINT' && moduleDetails?.environmentSpecific">Env</th>
                    <th *ngIf="moduleType !== 'ENDPOINT'">Env Mapper</th>
                    <th *ngIf="moduleDetails.showBrowserOptions">OS</th>
                    <th *ngIf="moduleDetails.showBrowserOptions">Browser</th>
                    <th>Active</th>
                    <th>Actions</th>
                    <th>Results</th>
                  </tr>
                </thead>
                <tbody class="bg-white">
                  <tr [ngClass]="selectedScehduleId === scheduledExecution.id && 'selectedRow'" *ngFor="let scheduledExecution of scheduledExecutions; index as index;">
                    <td><input type="checkbox" name="" [(ngModel)]="scheduledExecution.selected" value="scheduledExecution.id" (click)="optionToggledSchedule(index)" /></td>
                    <td>{{ scheduledExecution.name }}</td>
                    <td>{{ scheduledExecution.startDate | localDate }}</td>
                    <td>{{ scheduledExecution.cron }}</td>
                    <td *ngIf="moduleType === 'ENDPOINT' && moduleDetails?.environmentSpecific">
                      {{ scheduledExecution.environment?.name }}
                    </td>
                    <td *ngIf="moduleType !== 'ENDPOINT'">
                      {{ scheduledExecution.environmentMap?.name }}
                    </td>
                    <td *ngIf="moduleDetails.showBrowserOptions">
                      {{ scheduledExecution.os }}
                    </td>
                    <td *ngIf="moduleDetails.showBrowserOptions">
                      {{ scheduledExecution.browserType }}
                    </td>
                    <td>
                      <ui-switch [(ngModel)]="scheduledExecution.active" id="active" (valueChange)="onActiveChange($event, scheduledExecution)"></ui-switch>
                    </td>
                    <td class="pl-2">
                      <i class="far fa-edit clickable" (click)="isEdit = true; editSchedule(scheduledExecution)" click-to-scroll title="Edit this schedule"></i>
                      <i class="far fa-trash-alt text-danger clickable ml-2" (click)="deleteSchedule(scheduledExecution.id)" title="Delete this schedule"></i>
                    </td>
                    <td class="text-center">
                      <span class="clickable link-color" data-toggle="modal" data-target="#exampleModalLong" (click)="selectedScheduleName = scheduledExecution.name; getScheduledExecutionJobResults(scheduledExecution.id)">
                        <i class="fas fa-clipboard-list" style="font-size: 18px;" [ngClass]="selectedScehduleId === scheduledExecution.id && 'selectedTab'"></i>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <section class="row">
              <div class="col text-right" *ngIf="onActiveChangeTriggered">
                <button (click)="saveBulk()" class="btn btn-sm btn-primary">Save</button>
                <button (click)="resetBulk()" class="btn btn-sm btn-warning ml-2">Cancel</button>
              </div>
            </section>
          </div>
        </div>

        <!-- Detail of triggers -->
        <div class="col-4" #resultSection>
          <div class="justify-content-between d-flex common-section align-items-center ">
            <h5><b>
                Executions {{ selectedScheduleName && 'for ' + selectedScheduleName }}
                <i class="fas fa-sync float-right clickable pl-2" ngbTooltip="Refresh" placement="left" *ngIf="selectedScheduleName" (click)="refreshSchedule()"></i></b>
            </h5>
            <form [formGroup]="filterForm" class="search-form mr-2">
              <div class="form-row">
                <div class="d-flex">
                  <ng-select [items]="executionStatuses" (change)="filterByStatus()" class="custom" bindLabel="status" placeholder="Filter By Status" [searchable]="true" [multiple]="false" formControlName="executionStatus">
                    <ng-option [value]=""><i class="fa fa-filter">h</i>
                      Filter By Status</ng-option>
                  </ng-select>
                </div>
              </div>
            </form>
          </div>
          <div class="common-table">
            <div *ngIf="!scheduledExecutionJobResults" class="extra-box bg-white p-2">Click on <i>View</i> to see the
              scheduled
              execution</div>
            <div [ngbCollapse]="toggleExecutionJobResults">
              <table class="table bg-white schedule_executions text-center table-striped table-bordered" *ngIf="scheduledExecutionJobResults">
                <thead>
                  <tr class="font-bold">
                    <th>Triggered at</th>
                    <th>Status</th>
                    <th>Result</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let scheduleJobResult of scheduledExecutionJobResults">
                    <td>{{ scheduleJobResult.executedOn | localDate }}</td>
                    <td>{{ scheduleJobResult.executionStatus }}</td>
                    <td>
                      <a *ngIf="moduleType === 'ENDPOINT'" (click)="openResult(scheduleJobResult, 'endpoint')" class="clickable">Go to Results</a>
                      <a *ngIf="moduleType === 'TESTCASE'" (click)="openResult(scheduleJobResult, 'testcase')" class="clickable">Go to Results</a>
                      <a *ngIf="moduleType === 'TESTSUITE'" (click)="openResult(scheduleJobResult, 'testsuite')" class="clickable">Go to Results</a>
                      <a *ngIf="moduleType === 'MASTERSUITE'" (click)="openResult(scheduleJobResult, 'mastersuite')" class="clickable">Go to Results</a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="row mt-3" *ngIf="showScheduledExecutionJobResults" id="loadmore-box" class="text-center mt-3">
            <span *ngIf="this.moreData" class="load-more-button" (click)="loadMore(this.page)">LOAD MORE</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
